<div class="content-wrapper">
    <div class="page-header">
        <h3 class="page-title" style="cursor: context-menu;">
            <span class="page-title-icon bg-gradient-success text-white mr-2">
                <i class="mdi mdi-account-multiple menu-icon"></i>
            </span> รายชื่อโครงการที่ได้รับการสนับสนุนด้านการเงิน
        </h3>
    </div>
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card" style="border-radius: 15px;">
                <div class="card-body">
                    <form>
                        <div style="float: right; vertical-align: middle;margin-bottom: 10px;">

                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-gradient-success text-white"> ค้นหา </span>
                                </div>
                                <input type="text" class="form-control" list="id-project"
                                    [(ngModel)]="searchForm.value.type" id="search" name="search"
                                    (ngModelChange)="onClickSearch('search')" placeholder="ชื่อโครงการ"
                                    aria-describedby="basic-addon1">
                            </div>
                            <datalist id="id-project">
                                <option *ngFor="let data of data_all" [value]="data.project_name">{{data.project_name}}
                                </option>
                            </datalist>
                        </div>
                    </form>
                    <div class="table-responsive">
                        <table class="table table-striped" style="cursor: context-menu;"
                            *ngIf="data_funding.length != 0">
                            <thead>
                                <tr class="text-center">
                                    <th class="tab-10"> ลำดับเลขที่สัญญา </th>
                                    <th class="tab-20"> ประเภทเงิน </th>
                                    <th class="tab-30"> ชื่อโครงการ </th>
                                    <th class="tab-10"> ปีงบประมาณ </th>
                                    <th class="tab-10"> </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-center" *ngFor="let data of data_funding| paginate : {
                                                itemsPerPage: tableSize,
                                                currentPage: page,
                                                totalItems: count
                                              }; index as i;">
                                    <td class="tab-10"> {{data.debt_id}} </td>
                                    <td class="tab-20 text-left"> {{data.type_money}} </td>
                                    <td class="tab-30 text-left" title="{{data.project_name}}">
                                        {{data.project_name}} </td>
                                    <td class="tab-10"> {{data.fund_year}} </td>
                                    <td class="text-right tab-10">
                                        <button class="btn btn-light btn-sm" style="margin-right: 10px;"
                                            title="ดูเพิ่มเติม" (click)="onClickView(data)">
                                            <i class="mdi mdi-eye text-success"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <pagination-controls class="my-pagination" previousLabel="ก่อนหน้า" nextLabel="ถัดไป"
                            *ngIf="data_funding.length != 0" (pageChange)="onTableDataChange($event)"
                            style="text-align: center;">
                        </pagination-controls>
                        <div *ngIf="data_funding.length == 0" class="text-center" style="color: lightgray;">
                            <h3>ไม่พบรายการที่ค้นหา</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>